import { Pie } from "@antv/g2plot";
import get from "lodash/get";

const breakDownGraphConfig = (container, colors = []) => {
  if (!container) {
    return null;
  }

  const chart = new Pie(container, {
    data: [],
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    innerRadius: 0.7,
    color: colors,
    label: {
      type: 'inner',
      offset: '-50%',
      content: (datum) => `${get(datum, 'value')}`,
      style: {
        fill: '#fff',
        fontSize: 14,
        textAlign: 'center',
        textBaseline: 'middle',
        fontWeight: 600,
      },
      autoRotate: false,
      rotate: false,
    },
    forceFit: true,
    legend: { position: "right" },
    tooltip: {
      showTitle: false,
      formatter: (datum) => ({
        name: get(datum, "type"),
        value: get(datum, "value"),
      }),
    },
    interactions: [
      { type: "element-selected" },
      { type: "element-active" },
    ],
    annotations: [],
  });

  return chart;
};

export default breakDownGraphConfig;
